// Adrust page copy, verbatim from 2026-10-20-adrust-pagina-concept.md (NL only for now).
// **…** marks bold text. Placeholder line and meta lines intentionally left out.

export const ADRUST_PATH = "/adrust";
export const CALENDLY_URL = "https://calendly.com/ghiowebservices/15min";

export const adrust = {
  title: "Adrust",
  tagline: "Ik houd je Google Ads in de gaten.",
  intro: [
    "Je adverteert in Google. Maar weet je ook elke dag of dat geld goed terechtkomt? Ik kijk dagelijks mee.",
    "Gaat er iets mis, dan hoor je het meteen van mij, met advies erbij.",
  ],
  cta: "Plan een gesprek met Ghio",
  price: "€ 99 per maand, excl. btw. Maandelijks opzegbaar",
  probleem: {
    kop: "Het probleem",
    alineas: [
      "Google Ads loopt door, ook als niemand kijkt. Een budget dat wegloopt of een campagne die stilvalt, zie je vaak pas op de factuur.",
      "Een bureau dat je campagnes beheert, is duur. Zelf elke dag inloggen kost tijd, en je weet niet altijd waar je op moet letten. Daar zit Adrust tussenin.",
    ],
  },
  krijgt: {
    kop: "Wat je krijgt",
    items: [
      { kern: "Elke dag kijk ik mee.", tekst: "In een overzicht van je Google Ads: wat je uitgeeft en wat het oplevert." },
      { kern: "Meteen een bericht als het misgaat.", tekst: "Loopt een budget weg, stopt een campagne of schieten de kosten omhoog? Dan stuur ik je dezelfde dag een bericht, met wat ik je adviseer." },
      { kern: "Elke maand een overzicht.", tekst: "Kort en in gewone taal: hoe het ging en wat beter kan." },
      { kern: "Ik regel de koppeling.", tekst: "Jij hoeft niets in te richten. Ik loop de paar stappen samen met je door." },
    ],
  },
  nietDoe: {
    kop: "Wat ik niet doe",
    alineas: [
      "Ik pas zelf niets aan in je campagnes, ook niet in een noodgeval. Ik adviseer, jij of je eigen bureau voert het uit. Zo blijft jouw account van jou, en weet je altijd wie wat heeft gedaan.",
      "Wil je dat ik het wél voor je aanpas? Dan past een van mijn groeipakketten beter. Adrust is daar een mooie eerste stap naartoe.",
    ],
  },
  voorWie: {
    kop: "Voor wie",
    items: [
      "Je adverteert zelf in Google Ads en wilt weten of je geld goed besteed wordt.",
      "Je hebt een bureau dat je campagnes doet, en je wilt een tweede paar ogen dat met je meekijkt.",
      "Je hebt al Nachtrust voor je website. Adrust kun je er los bij nemen.",
    ],
    noot: "Alleen Google Ads. Voor advertenties op Facebook en Instagram heb ik een andere aanpak.",
  },
  hoe: {
    kop: "Hoe het gaat",
    stappen: [
      { kern: "Gesprek.", tekst: "We kijken samen of Adrust bij je past." },
      { kern: "Koppelen.", tekst: "Jij geeft mij toegang tot je Google Ads, ik zet de rest op." },
      { kern: "Meekijken.", tekst: "Vanaf dan kijk ik elke dag mee en krijg je elke maand je overzicht." },
    ],
  },
  vragen: {
    kop: "Vragen",
    items: [
      { q: "Krijg ik zelf een inlog?", a: "Nee. Je krijgt het overzicht van mij. Zo hoef je niets bij te houden." },
      { q: "Wat kost het?", a: "€ 99 per maand, excl. btw. Je advertentiebudget betaal je zelf aan Google. Dat zit er niet in." },
      { q: "Past je ook dingen aan?", a: "Nee, bij Adrust adviseer ik alleen. Wil je dat ik het beheer, dan kijken we samen naar een groeipakket." },
      { q: "Werkt het ook voor Facebook en Instagram?", a: "Nee, Adrust is alleen voor Google Ads." },
    ],
  },
  afsluiter: "Wil je weten of je Google Ads goed lopen? Plan een gesprek. Dan kijk ik met je mee.",
  // Short mention under the Nachtrust tiers (homepage, NL only).
  vermelding: {
    naam: "Adrust",
    prijs: "€ 99 per maand",
    tekst: "Ik houd je Google Ads in de gaten. Elke dag meekijken, meteen advies als er iets misgaat.",
    link: "Meer over Adrust →",
  },
};

export const adrustSeoInput = () => ({
  lang: "nl",
  nlPath: ADRUST_PATH,
  title: "Adrust · Ik houd je Google Ads in de gaten · Ghio",
  description: adrust.intro.join(" "),
  ogType: "website",
  jsonLd: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: adrust.vragen.items.map((v) => ({
      "@type": "Question",
      name: v.q,
      acceptedAnswer: { "@type": "Answer", text: v.a },
    })),
  },
});
